import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
import styled from "@emotion/styled";

interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean;
}

const StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  color: "#576078",
  fontWeight: "bold",
  fontSize: "1.6rem",
  fontFamily: "Comfortaa-Regular",
  ".MuiFormControlLabel-label": checked && {
    color: "#7aeacd",
  },
}));

function MyFormControlLabel(props: FormControlLabelProps) {
  const radioGroup = useRadioGroup();

  let checked = false;
  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

export const MuiRadioButton = (props: any) => {
  const { value, handleChange, data } = props;

  return (
    <RadioGroup
      row
      value={value}
      onChange={handleChange}
      sx={{
        justifyContent: "center",
        columnGap: {
          xs: 2,
          md: 5,
        },
      }}
    >
      {data.map((item: any,index:any) => {
        return (
          <MyFormControlLabel
            key={index}
            value={item.id}
            control={
              <Radio
                sx={{
                  color: "#576078",
                  "&.Mui-checked": {
                    color: "#7aeacd",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                  },
                }}
              />
            }
            label={item.label}
          />
        );
      })}
    </RadioGroup>
  );
};
